import src from "IMAGE";
export default { src, width: 1070, height: 381, blurWidth: 0, blurHeight: 0};
